module.exports = __webpack_public_path__ + "static/img/lflk.58cbb27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lflk.png
// module id = oufM
// module chunks = 1